import React, { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

import MyCollapse from 'components/Collapse';
import Spin from 'components/Spin';
import CopyText from 'v2/components/Shared/CopyText';
import type { ShoppingDelivery } from 'v2/interfaces/shopping';
import shoppingProductService from 'v2/services/shopping/product';

const ProducerContact = ({ delivery }: { delivery: ShoppingDelivery }) => {
  const [loadingProducerData, setLoadingProducerData] = useState<boolean>(false);
  const [producerData, setProducerData] = React.useState<ShoppingDelivery | null>(null);

  const handleClickProducerData = useCallback(async (invoiceId: string) => {
    setLoadingProducerData(true);
    shoppingProductService.producerContact(invoiceId).subscribe(res => {
      setProducerData(res.data);
      setLoadingProducerData(false);
    }, toast.error);
  }, []);

  return (
    <MyCollapse
      title='Contato com Produtor'
      onClick={() => handleClickProducerData(delivery.invoice_id.toString())}
      arrow
    >
      {loadingProducerData && <Spin />}

      {producerData && !loadingProducerData && (
        <div className='flex flex-col gap-1'>
          {producerData.producer.name && (
            <div className='text-sm'>
              <span className='font-semibold'>Nome:</span> {producerData.producer.name}
            </div>
          )}
          {producerData.producer.email && (
            <div className='text-sm'>
              <span className='font-semibold'>E-mail:</span> <CopyText value={producerData.producer.email} />
            </div>
          )}
          {producerData.producer.phone && (
            <div className='text-sm'>
              <span className='font-semibold'>Telefone:</span> <CopyText value={producerData.producer.phone} />
            </div>
          )}
          {producerData.producer.address && (
            <div className='text-sm'>
              <span className='font-semibold'>Endereço:</span> {`${producerData.producer.address}`}
            </div>
          )}
        </div>
      )}
    </MyCollapse>
  );
};

export default ProducerContact;
